import * as React from 'react'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import Navbar from '../setup/Navbar'
import { Container, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { restartSalesServices } from '../../features/AdminManagement/restartServicesSlice'
import Loading from '../../BuiltInComponent/Loading'

export default function RestartServices() {

    const dispatch = useDispatch()

    const { msg, isLoading } = useSelector(state => state.rs)
    const restartServicesHandler = () => {
        dispatch(restartSalesServices())
    }
    return (
        <>
            <Navbar />
            <Container>
                <HeadingText text="Restart Services" />
                <ButtonNormal text='Restart Services' onClick={restartServicesHandler} />
                {isLoading && <Loading />}
                {msg && msg.length > 0 &&
                    <Typography sx={{ color: 'green', textAlign: 'center' }} variant="h4" gutterBottom>
                        {msg[0].msg}
                    </Typography>}
            </Container>
        </>
    )
}